export interface DatiReportCOAU {
  comune: string;
  provincia: string;
  indirizzo: string;
  latitudine: string;
  longitudine: string;
  quota: string;
  tipoTerreno: string;
  oraAccertamento: string;
  oraRichiesta: string;
  richiestaPer: string;
  valoreBruciato: number | null;
  tipologiaBruciato: string;
  ettariBruciato: string;
  valoreRischio: number | null;
  tipologiaRischio: string;
  ettariRischio: string;
  fronteUnico: string;
  fronteDiversiN: string;
  fronteDiversiMt: string;
  intensitaVento: string;
  direzioneVento: { direzione: string; nome: string } | null;
  ostacoliCompilati: string[];
  ostacoliDirezioni: Record<string, string>;
  ostacoliTerraCompilati: string[];
  ostacoliTerraDirezioni: Record<string, string>;
  elettrodotto: { stato: string; tensione: string; direzione: string };
  visibilitaNote: string;
  fonteIdricaAerei: {
    regione: string;
    bacino: string;
    bacinoData?: { cat: string; coords: string } | null;
    distanza?: string;
  };
  fonteIdricaElicotteri: { dettagli: string };
  coordinatore: string;
  numeroPersone: string;
  nominativoDOS: string;
  radioFrequenzaTBT: string;
  squadre: string;
  aeromobiliReg: string;
  nomeAeromobile: string;
  radioAeromobile: string;
  ritardante: string;
  noteRitardante: string;
  firma: string;
}

export function generaReportCOAU(dati: DatiReportCOAU, ora?: string): string {
  const now = ora ?? new Date().toLocaleString('it-IT');

  return `
╔════════════════════════════════════════════════════════════════╗
║                    SCHEDA C.O.A.U.                             ║
║        Centro Operativo Aereo Unificato                        ║
╚════════════════════════════════════════════════════════════════╝

Data Generazione: ${now}

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
📍 LOCALIZZAZIONE
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
Comune: ${dati.comune}
Provincia: ${dati.provincia}
Località/Indirizzo: ${dati.indirizzo}
Coordinate: ${dati.latitudine}, ${dati.longitudine}
Quota: ${dati.quota} m s.l.m.
Tipo Terreno: ${dati.tipoTerreno}

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
⏰ ORARIO
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
Ora Accertamento Incendio: ${dati.oraAccertamento}
Ora Richiesta al COAU: ${dati.oraRichiesta}
Richiesta Per: ${dati.richiestaPer}

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
🌿 VEGETAZIONE
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
BRUCIATA:
  Valore Ambientale: ${dati.valoreBruciato || 'N/A'}
  Tipologia: ${dati.tipologiaBruciato || 'N/A'}
  Ettari: ${dati.ettariBruciato || 'N/A'} ha

A RISCHIO:
  Valore Ambientale: ${dati.valoreRischio || 'N/A'}
  Tipologia: ${dati.tipologiaRischio || 'N/A'}
  Ettari: ${dati.ettariRischio || 'N/A'} ha

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
🔥 FRONTE DEL FUOCO
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
Unico: ${dati.fronteUnico} mt
Diversi N°: ${dati.fronteDiversiN}
Diversi: ${dati.fronteDiversiMt} mt

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
💨 VENTO
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
Intensità: ${dati.intensitaVento}
Direzione: ${dati.direzioneVento?.direzione || 'N/A'} (${dati.direzioneVento?.nome || 'N/A'})

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
✈️ OSTACOLI AEREI
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
${dati.ostacoliCompilati.map(o => {
    if (o === 'Elettrodotti') {
      return `${o}:\n  Stato: ${dati.elettrodotto.stato}\n  Tensione: ${dati.elettrodotto.tensione}\n  Direzione: ${dati.elettrodotto.direzione}`;
    } else if (o === 'Visibilità') {
      return `${o}: ${dati.visibilitaNote}`;
    } else {
      return `${o}: ${dati.ostacoliDirezioni[o] || 'N/A'}`;
    }
  }).join('\n')}

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
🏗️ OSTACOLI A TERRA
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
${dati.ostacoliTerraCompilati.map(o =>
    `${o}: ${dati.ostacoliTerraDirezioni[o] || 'N/A'}`
  ).join('\n')}

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
💧 FONTE IDRICA
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
AEREI:
  Regione: ${dati.fonteIdricaAerei.regione}
  Bacino: ${dati.fonteIdricaAerei.bacino}
  ${dati.fonteIdricaAerei.bacinoData ? `Categoria: ${dati.fonteIdricaAerei.bacinoData.cat}` : ''}
  ${dati.fonteIdricaAerei.bacinoData ? `Coordinate: ${dati.fonteIdricaAerei.bacinoData.coords}` : ''}
  ${dati.fonteIdricaAerei.distanza ? `Distanza: ${dati.fonteIdricaAerei.distanza}` : ''}

ELICOTTERI:
  ${dati.fonteIdricaElicotteri.dettagli}

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
👥 PERSONALE E MEZZI
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
Coordinatore: ${dati.coordinatore}
N° Persone: ${dati.numeroPersone}
Nominativo DOS: ${dati.nominativoDOS}
Radio Frequenza T.B.T.: ${dati.radioFrequenzaTBT}
Squadre: ${dati.squadre}
Aeromobili Reg.: ${dati.aeromobiliReg}
${dati.aeromobiliReg === 'SI' ? `  Nome Aeromobile: ${dati.nomeAeromobile}\n  Radio Aeromobile: ${dati.radioAeromobile}` : ''}

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
🧯 RITARDANTE
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
Utilizzo: ${dati.ritardante}
Note: ${dati.noteRitardante}

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
✍️ FIRMA
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
${dati.firma}

╔════════════════════════════════════════════════════════════════╗
║           Fine Report - Generato da DOS518                     ║
╚════════════════════════════════════════════════════════════════╝
`;
}
